import React, { useState } from "react";
import "../css/mobileapp.css";
import { FaCloudUploadAlt, FaCheckCircle } from "react-icons/fa";
import logo1 from "../assets/logo.png";

export default function VideoUpload() {
  const [video, setVideo] = useState(null);
  const [preview, setPreview] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleVideoChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setVideo(file);
    setPreview(URL.createObjectURL(file));
    setSuccess(false);
  };

        const handleUpload = async () => {
        if (!video) {
            alert("⚠️ முதலில் வீடியோ தேர்வு செய்யவும்");
            return;
        }

        setUploading(true);
        setSuccess(false);

        const formData = new FormData();
        formData.append("video", video);

        try {
            const res = await fetch("https://tvk-backend-yl1b.onrender.com/api/upload-video", {
            method: "POST",
            body: formData,
            });

            if (res.ok) {
            setSuccess(true);
            } else {
            alert("Upload failed");
            }
        } catch (err) {
            alert("Server error");
        }

        setUploading(false);
        };

  return (
    <div className="mobile-container">
      {/* HEADER */}
      <div className="mobile-header">
        <img src={logo1} alt="TVK Logo" className="mobile-logo" />
      </div>

      <div className="contact-page">
        <h2 className="contact-title"> வீடியோ பதிவேற்று</h2>

        {/* Upload Box */}
        <div className="video-upload-box">
          <label className="upload-label">
            <FaCloudUploadAlt size={40} />
            <span>வீடியோ தேர்வு செய்ய</span>
            <input
              type="file"
              accept="video/*"
              onChange={handleVideoChange}
              hidden
            />
          </label>
        </div>

        {/* Preview */}
        {preview && (
          <div className="video-preview">
            <video src={preview} controls width="100%" />
          </div>
        )}

        {/* Upload Button */}
        <button className="upload-btn" onClick={handleUpload}>
           பதிவேற்று
        </button>

        {/* Uploading Animation */}
        {uploading && (
          <div className="uploading">
            <div className="spinner"></div>
            <p>பதிவேற்றப்படுகிறது...</p>
          </div>
        )}

        {/* Success Message */}
        {success && (
          <div className="upload-success">
            <FaCheckCircle color="green" size={24} />
            <p>✅ வீடியோ வெற்றிகரமாக பதிவேற்றப்பட்டது!</p>
          </div>
        )}
      </div>
    </div>
  );
}